import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const immigration = [
  comingSoonRoute({
    path: '/immigration/legalization-of-stay',
    name: 'immigration-legalization-of-stay',
    comingSoonKey: 'immigrationLegalizationOfStay',
    resource: PRIVATE.IMMIGRATION.LEGALIZATION_OF_STAY,
    chickenImage: 'immigration.png',
  }),
  comingSoonRoute({
    path: '/immigration/legalization-of-work',
    name: 'immigration-legalization-of-work',
    comingSoonKey: 'immigrationLegalizationOfWork',
    resource: PRIVATE.IMMIGRATION.LEGALIZATION_OF_WORK,
    chickenImage: 'immigration.png',
  }),
  comingSoonRoute({
    path: '/immigration/processes',
    name: 'immigration-processes',
    comingSoonKey: 'immigrationProcesses',
    resource: PRIVATE.IMMIGRATION.PROCESSES,
    chickenImage: 'immigration.png',
  }),
]

export default immigration
